var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Title',{attrs:{"title":""}}),_c('div',{staticClass:"containerImage"},[_c('div',{staticClass:"imagePreview"},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"oliver-consulting"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }